import {_Staff as Staff} from "./_Staff";
import {_TimeoffRequests as TimeoffRequests} from "./_TimeoffRequests";
import {_LeaveRequests as LeaveRequests} from "./_LeaveRequests";
import {_PaySlips as PaySlips} from "./_PaySlips";
import {_Files as Files} from "./_Files";
import {_Expenses as Expenses} from "./_Expenses";
import {_AwayTrips as AwayTrips} from "./_AwayTrips";

export const ModuloHRAPI = {
    Staff: Staff,
    TimeoffRequests: TimeoffRequests,
    LeaveRequests: LeaveRequests,
    PaySlips: PaySlips,
    Files: Files,
    Expenses: Expenses,
    AwayTrips: AwayTrips
};
